import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static outlets = ["side-panel"];

  openSidePanel(e) {
    this.sidePanelOutlet.open(e.currentTarget.dataset.url);
  }
}
